import React from "react"

import {
    Button,
    Chip,
    Typography,
} from "@mui/material"

import {
    t,
    Trans,
} from "@lingui/macro"

import { renderProgress } from "components/filledProgressBar/filledProgressBar"

import { getChipProps } from "components/commons/asset-chip-props"
import { GridValueGetterParams } from "@mui/x-data-grid"
import {Link} from "react-router-dom";

const defaultColumnDefinition: any = {
    field: "",
    headerName: "",
    headerAlign: "left",
    align: "left",
}
const getCompatibleTableColumns = (): any => {
    return [
        {
            ...defaultColumnDefinition,
            field: "locality",
            headerName: t({
                id: "compatible-table.locality",
                message: "Località",
                comment: "in compatible table, locality",
            }),
            flex: 2,
            valueGetter: (params: GridValueGetterParams) => {
                return params.row.asset.address
            },
        },
        {
            ...defaultColumnDefinition,
            field: "propertyType",
            headerName: t({
                id: "compatible-table.property-type",
                message: "Tipo proprietà",
                comment: "in compatible table, property type",
            }),
            flex: 0.75,
            valueGetter: (params: GridValueGetterParams) => {
                if(params.row.asset.characteristics.type === "PLOT_OF_LAND") {
                    return "Terreno"
                } else {
                    return "Immobile"
                }
            },
        },
        {
            ...defaultColumnDefinition,
            field: "dimension",
            headerName: t({
                id: "compatible-table.dimension",
                message: "Dimensione",
                comment: "in compatible table, dimension",
            }),
            flex: 0.75,
            valueGetter: (params: GridValueGetterParams) => {
                return params.row.asset.characteristics.gla + " mq"
            },
        },
        {
            ...defaultColumnDefinition,
            field: "state",
            headerName: t({
                id: "compatible-table.state",
                message: "Stato",
                comment: "in compatible table, state",
            }),
            flex: 0.75,
            renderCell: (params: GridValueGetterParams) => {
                let state: string
                if(params.row.asset.characteristics.status === "AVAILABLE") {
                    state = "Disponibile"
                } else if(params.row.asset.characteristics.status === "NOT_AVAILABLE") {
                    state = "Non disponibile"
                } else {
                    state = "In contrattazione"
                }

                return <Chip {...getChipProps(state)} />
            }
        },
        {
            ...defaultColumnDefinition,
            field: "compatibility",
            headerName: t({
                id: "compatible-table.affinity",
                message: "Compatibilità",
                comment: "in compatible table, affinity",
            }),
            flex: 1,
            renderCell: (params: { row: any }) => {
                return (
                    renderProgress(params.row.compatibility)
                )
            }
        },
        {
            ...defaultColumnDefinition,
            field: "details",
            headerName: t({
                id: "compatible-table.details",
                message: "Dettagli",
                comment: "in brand table, details",
            }),
            width: 200,
            renderCell: (params: any) => (
                <Link key={params.row.id} to={`/match/${params.row.id}`}>
                    <Button
                        variant="contained"
                        disableElevation
                        sx={{
                            textTransform: 'none',
                            backgroundColor: 'secondary.main',
                            color: 'white',
                            paddingX: 5,
                            height: 28,
                        }}>
                        <Typography>
                            <Trans id="brand-table.view-details">
                                Vedi dettagli
                            </Trans>
                        </Typography>
                    </Button>
                </Link>
            ),
        },
    ]
}

export default getCompatibleTableColumns
